import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "../components/screens/layout";
import RecordsPage from "../pages/records";
import CalendarPage from "../pages/calendar";
import AlarmsPage from "../pages/alarms";
import LoginPage from "../pages/login";
import ProtectedRoute from "./protected-routes";
import ForgotPasswordPage from "../pages/forgot-password";

import RecordPage from "../pages/record";
import Information from "../pages/record/information";
import Appointments from "../pages/record/appointments";
import Budgets from "../pages/record/budgets";
import BudgetLines from "../pages/record/budget-lines";
import Notes from "../pages/record/notes";
import Invoices from "../pages/record/invoices";
import Files from "../pages/record/files";
import Reminders from "../pages/record/reminders";
import CreateRecord from "../pages/create-record";
// New pages
import AppointmentsPage from "../pages/appointments";
import AppointmentsPendingPage from "../pages/appointments-pending";
import AppointmentsUpcomingPage from "../pages/appointments-upcoming";
import AppointmentsHistoryPage from "../pages/appointments-history";
import AppointmentsManagementPage from "../pages/appointments-management";
import UserManagementPage from "../pages/user-management";
import UserEditPage from "../pages/user-edit";
import ProfilePage from "../pages/profile";
import DashboardPage from "../pages/dashboard";
import StatisticsPage from "../pages/statistics";
import CallsPage from "../pages/calls";
import ListasPage from "../pages/listas";
import TablasPage from "../pages/tablas";
import CobrosHonorariosPage from "../pages/cobros-honorarios";


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* Redirect based on role */}
        <Route index element={<RoleBasedRedirect />} />

        {/* Administrative and Superuser Routes */}
        <Route
          path="dashboard"
          element={
            <ProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]}>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        {/* Statistics Page - Solo ROLE_ADMIN */}
        <Route
          path="statistics"
          element={
            <ProtectedRoute allowedRoles={["ROLE_ADMIN"]}>
              <StatisticsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="alarms"
          element={
            <ProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_USER", "ROLE_MANAGER"]}>
              <AlarmsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="records"
          element={
            <ProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_USER", "ROLE_MANAGER"]}>
              <RecordsPage />
            </ProtectedRoute>
          }
        />

        {/* New Appointments Management Page (different from ROLE_OPERARIO appointments) */}
        <Route
          path="appointments-management"
          element={
            <ProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]}>
              <AppointmentsManagementPage />
            </ProtectedRoute>
          }
        />

        {/* Shared Routes */}
        <Route
          path="calendar"
          element={
            <ProtectedRoute>
              <CalendarPage />
            </ProtectedRoute>
          }
        />

        {/* ROLE_OPERARIO Routes */}
        <Route
          path="appointments"
          element={
            <ProtectedRoute allowedRoles={["ROLE_OPERARIO", "ROLE_USER"]}>
              <AppointmentsPage />
            </ProtectedRoute>
          }
        />

        {/* ROLE_OPERARIO - Citas Pendientes */}
        <Route
          path="appointments-pending"
          element={
            <ProtectedRoute allowedRoles={["ROLE_OPERARIO"]}>
              <AppointmentsPendingPage />
            </ProtectedRoute>
          }
        />

        {/* ROLE_OPERARIO - Próximas Citas */}
        <Route
          path="appointments-upcoming"
          element={
            <ProtectedRoute allowedRoles={["ROLE_OPERARIO"]}>
              <AppointmentsUpcomingPage />
            </ProtectedRoute>
          }
        />

        {/* ROLE_OPERARIO - Historial de Citas */}
        <Route
          path="appointments-history"
          element={
            <ProtectedRoute allowedRoles={["ROLE_OPERARIO"]}>
              <AppointmentsHistoryPage />
            </ProtectedRoute>
          }
        />

        {/* ROLE_USER Routes */}

        <Route
          path="user-management"
          element={
            <ProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]}>
              <UserManagementPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="user-edit/:userId"
          element={
            <ProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]}>
              <UserEditPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />

        <Route path="/create-record" element={
          <ProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_USER", "ROLE_MANAGER"]}>
            <CreateRecord />
          </ProtectedRoute>
        } />

        <Route path="/calls" element={
          <ProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_USER", "ROLE_MANAGER"]}>
            <CallsPage />
          </ProtectedRoute>
        } />

        <Route path="/listas" element={
          <ProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_USER", "ROLE_MANAGER"]}>
            <ListasPage />
          </ProtectedRoute>
        } />

        <Route path="/tablas" element={
          <ProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_USER", "ROLE_MANAGER"]}>
            <TablasPage />
          </ProtectedRoute>
        } />

        <Route path="/cobros-honorarios" element={
          <ProtectedRoute allowedRoles={["ROLE_ADMIN"]}>
            <CobrosHonorariosPage />
          </ProtectedRoute>
        } />

        <Route
          path="record/:id"
          element={
            <ProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_USER", "ROLE_MANAGER"]}>
              <RecordPage />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="information" replace />} />
          
          <Route path="information" element={<Information />} />
          <Route path="appointments" element={<Appointments />} />
          <Route path="budgets" element={<Budgets />} />
          <Route path="budget-lines" element={<BudgetLines />} />
          <Route path="notes" element={<Notes />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="files" element={<Files />} />
          <Route path="reminders" element={<Reminders />} />
        </Route>
      </Route>
    </Routes>
  );
};

// Component to redirect based on role
const RoleBasedRedirect = () => {
  const userRole = localStorage.getItem("userRole") || "";

  switch (userRole) {
    case "ROLE_OPERARIO":
      return <Navigate to="/appointments-pending" replace />;
    case "ROLE_USER":
      return <Navigate to="/alarms" replace />;
    case "ROLE_MANAGER":
      return <Navigate to="/appointments-management" replace />;
    case "ROLE_ADMIN":
    default:
      return <Navigate to="/alarms" replace />;
  }
};

export default AppRoutes;
